import { pageNote } from '../interfaces/pageNote';
import { BookService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';

declare var pdfjsLib;

class NotesPanelController {
	
	private bookID: string;
	
	public pageNotes: Array<pageNote>;
	public pageIds: string;
	public viewAs: string;
	public printOptions: Array<any> = [];
	public optionToPrint: string = '0';
	public notesToPrint: any = {};
	public isNotesVisible;
	
	// @ngInject
	constructor(
		private $scope			: ng.IScope,
		private $timeout		: ng.ITimeoutService,
		private $location		: ng.ILocationService,
		private bookService		: BookService,
		private observerService	: ObserverService
	) {}
	
	public $onInit = () => {
		this.observerService.attach( this.addNewNote, 'canvasCoordinateClicked' );
		this.observerService.attach( this.openNote, 'selectedNote' );
		
		this.bookID = this.$location.search().bookID;
		
		this.getPrintOptions();
		
		(window as any).html2canvas = html2canvas;
	}
	
	private getPrintOptions = () => {
		let defaultOption = {
			pageNumberStart: 0,
			pageNumberEnd: 0,
			label: 'All Units',
			value: '',
			bookID: this.bookID
		};
		
		this.printOptions.push( defaultOption );
		
		this.bookService.getChaptersByBookID( this.bookID ).then( data => {
			let chapters = data;
			let unitChapters = chapters.filter( chapter => chapter.title.toLowerCase().indexOf('unit') > -1 );
			
			for ( let i = 0; i < unitChapters.length; i++ ) {
				let unit = unitChapters[ i ];
				
				let pageStart = unit.pageStart;
				let pageEnd = ( 'undefined' !== typeof unitChapters[ i + 1 ] ) ? unitChapters[ i + 1 ].pageStart : 10000;
				
				this.printOptions.push({
					pageNumberStart: pageStart,
					pageNumberEnd: pageEnd,
					label: unit.title,
					value: unit.chapterID,
					bookID: this.bookID
				});
			}
		})
	}
	
	public saveNote = ( index ) => {
		
		this.pageNotes[ index ].note = angular.copy( this.pageNotes[ index ].editNoteText );
		
		if(this.pageNotes[ index ].pageNoteID.length){
			this.pageNotes[ index ].modifiedDateTime = Date.now();
		}
		
		this.pageNotes[ index ].editMode = false;
		
		let data = {
			bookID: this.bookID,
			pageID: this.pageNotes[ index ].page_pageID,
			note: this.pageNotes[ index ].note,
			pageNoteID: this.pageNotes[ index ].pageNoteID,
			xCoordinate: this.pageNotes[ index ].xCoordinate,
			yCoordinate: this.pageNotes[ index ].yCoordinate,
		}
		
		this.bookService.saveNote( data ).then( data => {
			if ( data.successfulActions.indexOf('addPageNote') > -1 ) {
				this.pageNotes[ index ].pageNoteID = data.pageNoteID;
				this.bookService.addNoteToCache( this.pageNotes[ index ] );
			}
		})
	}
	
	public togglePanel = (): void => {
		this.isNotesVisible = !this.isNotesVisible;
	}
	
	public openNote = ( index ): void => {
		
		// If the notes panel isn't open, open it.
		if ( !angular.element('.dashboard-wrapper').hasClass('open-right-panel') ) {
			this.togglePanel();
		}
		
		this.pageNotes.map( note => {
			note.isOpen = false
		});
		
		this.pageNotes[ index ].isOpen = true;
	}
	
	public toggleEditNote = ( index ): void => {
		
		this.pageNotes[ index ].editNoteText = angular.copy( this.pageNotes[ index ].note );
		this.pageNotes[ index ].editMode = ( 
			'undefined' === typeof this.pageNotes[ index ].editMode 
			|| !this.pageNotes[ index ].editMode 
		);
		
		// If this was a new note, delete it from the pageNotes array.
		if ( !this.pageNotes[ index ].editMode && !this.pageNotes[ index ].pageNoteID.length ) {
			this.pageNotes.splice( index, 1 );
		}
	}
	
	public addNewNote = ( coordinates ): void => {
		
		// If we already have a new note, return.
		if ( this.pageNotes.filter( note => note.pageNoteID === '' ).length > 0 ) {
			return;
		}
		
		var now = Date.now();
		
		this.pageNotes.push({
			page_pageID: coordinates.pageID,
			note: '',
			editNoteText: '',
			pageNoteID: '',
			xCoordinate: coordinates.x,
			yCoordinate: coordinates.y,
			spreadX: coordinates.spreadX,
			editMode: true,
			createdDateTime: now,
			modifiedDateTime: now
		} as pageNote );
		
		this.openNote( this.pageNotes.length - 1 );
		
		// Give a generous amount of time for the new PageNote to render.
		this.$timeout( () => {
			// Scroll to the bottom of the content area to see the new note.
			let rightPanel = document.getElementById('notes-scroll-panel');
			
			rightPanel.scrollTop = rightPanel.scrollHeight;
		}, 100 )
	}
	
	public deleteNote = ( index ) => {
		
		let deleteConfirmation = confirm('Are you sure you want to delete this note?');
		if ( deleteConfirmation ) {
			let pageNoteID = this.pageNotes[ index ].pageNoteID;
			
			this.bookService.deleteNote( pageNoteID ).then( data => {
				if ( data.successfulActions.indexOf('deletePageNote') > -1 ) {
					this.bookService.removeNoteFromCache( this.pageNotes[ index ] );
					this.pageNotes.splice( index, 1 );
				}
			})
		}
	}
	
	private sortNotesByPage = ( notes ) => {
		this.notesToPrint = {};
		for ( let i = 0; i < notes.length; i++ ) {
			let note = notes[ i ];
			
			if ( 'undefined' === typeof this.notesToPrint[ note.page_pageNumber ] ) {
				this.notesToPrint[ note.page_pageNumber ] = {};
				this.notesToPrint[ note.page_pageNumber ].notes = [];
				this.notesToPrint[ note.page_pageNumber ].image = note.page_s3PathToThumbnail;
			}
			
			this.notesToPrint[ note.page_pageNumber ].notes.push( note );
		}
		
		console.log( this.notesToPrint );
	}
	
	public printNotes = () => {
		let option = this.printOptions[ this.optionToPrint ];
		
		this.bookService.getPageNotesForBook( option ).then( data => {
			
			let notes = this.sortNotesByPage( data );
			
			this.$timeout( () => {
				let doc = new jsPDF({ format: 'a4' })
				var a4Width = Number( doc.internal.pageSize.getWidth() );
				doc.fromHTML(
					document.getElementById('print-notes').innerHTML, 
					15, 
					15, 
					{
						elementHandlers: function() {
							return true
						},
						pagesplit: true,
						'width': a4Width - 30,
					}, function() {
						doc.save('notes.pdf');
					}
				)
			}, 300 );
		});
	}
}

class NotesPanel {
	public restrict: string = 'EA';
	public scope: boolean = true;

	public bindToController: any = {
		pageNotes: '<',
		pageIds: '<',
		viewAs: '<',
		isNotesVisible: '='
	};

	public controller = NotesPanelController;
	public controllerAs = 'notesPanel';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/notes-panel.html';

	public static Factory() {
		return () => new this();
	}
}

export { NotesPanel };
